<template>
  <div class="border rounded-lg shadow-lg m-2 transition bg-white overflow-hidden"
       @touchstart="toggleAnimation($event)" @touchend="toggleAnimation($event)">
    <img :src="service.photo.path" alt="">

    <div class="m-2 text-sm text-center">
      <span>{{ service.name }}</span>
    </div>

  </div>
</template>

<script>
export default {
  name: "VerticalServiceCard",
  props: ['service'],
  methods: {
    toggleAnimation(event) {
      event.currentTarget.classList.toggle('scale-95')
      event.currentTarget.classList.toggle('shadow-lg')
    }
  }
}
</script>

<style scoped>

</style>